export class AppEvents {
	//Loading
	public static readonly PIXI_RESOURCE_LOADED: string = 'PIXI_RESOURCE_LOADED';
	public static readonly AJAX_HTML_LOADED: string = 'AJAX_HTML_LOADED';
	public static readonly INTIAL_PRELOAD_COMPLETE: string = 'INTIAL_PRELOAD_COMPLETE';
	public static readonly DEEP_LINK_LOADER_COMPLETE: string = 'DEEP_LINK_LOADER_COMPLETE';

	public static readonly VIEW_SETUP: string = 'VIEW_SETUP';

	//Section chanegs / site naviagtion
	public static readonly CHANGE_SECTION: string = 'CHANGE_SECTION';
	public static readonly SET_INTIAL_STATE: string = 'SET_INTIAL_STATE';
	public static readonly POP_HISTORY_STATE: string = 'POP_HISTORY_STATE';

	//Legacy, siwtch all to use change section...
	public static readonly WORK_DEPARMENT_SELECTED: string = 'WORK_DEPARMENT_SELECTED';
	public static readonly PROJECT_SELECTED: string = 'PROJECT_SELECTED';

	public static readonly CLOSE_PROJECT: string = 'CLOSE_PROJECT';
	public static readonly EXIT_PROJECT_PRESS: string = 'EXIT_PROJECT_PRESS';
	public static readonly DEBUG_LOGO_PRESS: string = 'DEBUG_LOGO_PRESS';
	public static readonly SCROLL_WHEEL_NO_TARGET: string = 'SCROLL_WHEEL_NO_TARGET';

	public static readonly ACTIVE_DEPARTMENT_NAV_MENU_PRESS: string = 'ACTIVE_DEPARTMENT_NAV_MENU_PRESS';
	public static readonly MENU_STATE_CHANGE: string = 'MENU_STATE_CHANGE';
	public static readonly RESET_NAV_MENU: string = 'RESET_NAV_MENU';

	public static readonly APP_RESIZE: string = 'APP_RESIZE';
}
